/**
 * Form dialogs go fullScreen on an xs viewport (E2.1 design spec section 8:
 * phones are a primary access mode, and a `maxWidth="xs"` modal dialog is
 * too cramped once the viewport itself is that narrow). Shared by every
 * multi-field form dialog (Role/Shop/ShopEdit/Owner/OwnerShops/User/Report)
 * so the useMediaQuery(theme.breakpoints.down('sm')) check lives in one
 * place instead of 7 copies. ConfirmDialog is deliberately NOT wired to
 * this -- small confirmation prompts look wrong stretched fullscreen.
 */
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export function useFullScreenDialog(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
}

export default useFullScreenDialog;
